import React from "react";

/* BEAMLUX brand mark: projector lens emitting a light beam */
export const LogoMark = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    {/* beam cone */}
    <path d="M10.5 12 L22.5 5.6 L22.5 18.4 Z" fill="rgba(226,238,252,0.22)" />
    <path d="M10.5 12 L22.5 8.4 L22.5 15.6 Z" fill="rgba(226,238,252,0.45)" />
    {/* lens */}
    <circle cx="7.6" cy="12" r="5.1" fill="#0a0c11" stroke="#56E3FF" strokeWidth="1.7" />
    <circle cx="7.6" cy="12" r="2.1" fill="#56E3FF" />
  </svg>
);

export const Logo = ({ markClass = "h-5 w-5", textClass = "text-xl" }) => (
  <>
    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl hairline shrink-0">
      <LogoMark className={markClass} />
    </span>
    <span className={`font-display font-semibold tracking-tight ${textClass}`}>
      BEAM<span className="text-cyanx">LUX</span>
    </span>
  </>
);
